import _ from 'lodash';

export const versionsAdapter = (vincheck) => _.get(vincheck, 'vehicle.versions', null);
